import { canResolveFromProject } from '@next-adapter/package-json/can-resolve-from-project.js'
import { hasDeclaredPackage } from '@next-adapter/package-json/has-declared-package.js'
import { readProjectPackageJson } from '@next-adapter/package-json/read-project-package-json.js'

export function hasProjectDependency(cwd: string, dependency: string): boolean {
  const pkg = readProjectPackageJson(cwd)
  return hasDeclaredPackage(pkg, dependency) && canResolveFromProject(cwd, dependency)
}
